import React from "react";
import { useIntl } from "react-intl";

import { ModalComponent } from "@app/core/modal";
import { BasicModal } from "@app/modules/basic-modal";

interface IConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Generic "are you sure?" confirmation modal for the dashboard's mutating actions. */
const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel }: IConfirmModalProps): JSX.Element => {
  const intl = useIntl();

  return (
    <ModalComponent title={title} isModalOpen={isOpen} onCloseModal={onCancel} variant="small">
      <BasicModal
        description={message}
        onApprove={onConfirm}
        onApproveTitle={intl.formatMessage({ id: "productPageSync.confirm.confirm" })}
        onCancel={onCancel}
        onCancelTitel={intl.formatMessage({ id: "productPageSync.confirm.cancel" })}
      />
    </ModalComponent>
  );
};

export { ConfirmModal };
